<div class="card flex min-h-0 flex-1 flex-col overflow-hidden">
  <h3>Reports</h3>

  <re-report-filters
    (filterValuesEvent)="setFilterData($event)"
  ></re-report-filters>

  {{ offshoreReportsStore.entities().length }} reports found.
  @if (offshoreReportsStore.entities().length > 0) {
    <div class="flex min-h-0 flex-1 flex-col overflow-hidden">
      <nsp-table
        class="min-h-0 flex-1"
        [items]="filteredReports()"
        [columns]="columns"
        (selectChanged)="handleTableRowSelect($event)"
      />
    </div>
  }
</div>
